function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 7.5,
  cy: 7.5,
  r: 7.5,
  fill: "#000"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7 3.5v5l4 1.5",
  stroke: "#C9EDFB",
  strokeWidth: 1.2
});

var SvgClockBlack = function SvgClockBlack(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml,%3Csvg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg' %3E %3Ccircle cx='7.5' cy='7.5' r='7.5' fill='black' /%3E %3Cpath d='M7 3.5V8.5L11 10' stroke='%23C9EDFB' stroke-width='1.2' /%3E %3C/svg%3E";
export { SvgClockBlack as ReactComponent };